var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96429 18.9286C14.9151 18.9286 18.9286 14.9151 18.9286 9.96429C18.9286 5.01345 14.9151 1 9.96429 1C5.01345 1 1 5.01345 1 9.96429C1 14.9151 5.01345 18.9286 9.96429 18.9286Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96433 18.331C11.7646 18.331 13.2241 14.5851 13.2241 9.96432C13.2241 5.34354 11.7646 1.59766 9.96433 1.59766C8.16403 1.59766 6.70459 5.34354 6.70459 9.96432C6.70459 14.5851 8.16403 18.331 9.96433 18.331Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62988 14.7548C4.55945 13.8642 7.11984 13.4189 10.311 13.4189C13.5023 13.4189 16.0626 13.8642 17.9922 14.7548",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62988 5.88973C4.55945 6.7803 7.11984 7.22559 10.311 7.22559C13.5023 7.22559 16.0626 6.7803 17.9922 5.88973",
    stroke: "#202020",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.69815f0aff0d9c96b3f27b780db384d1.svg";
export { ForwardRef as ReactComponent };